module.exports = __webpack_public_path__ + "img/logo.d086dcd8.jpg";